import zfield from "./zfield.vue";
import zselect from "./zselect.vue";

export default {
    install(vue) {
        vue.component(zfield.name, zfield)
        vue.component(zselect.name, zselect)
    },
};
